export default __webpack_public_path__ + "static/media/seva-assets1.9c7426aa.png";